<div class="paragraph-holder px-0 col-12" *ngIf="cmsComponent.data$ | async as data">
  <div [ngClass]="data?.styleClasses">
    <py-read-more
      [content]="data?.content"
      *ngIf="hasClass(data?.styleClasses, 'paragraph-read-more'); else defaultTemplate"
    ></py-read-more>

    <ng-template #defaultTemplate>
      <i *ngIf="hasClass(data?.styleClasses, 'paragraph-registration-opens')" nz-icon nzType="calendar" nzTheme="outline"></i>
      <div [innerHTML]="bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)"></div>
    </ng-template>
  </div>
</div>
